import cues from "./juice-cues.json";

let context: AudioContext | undefined;
let unlocked = false;
let last = 0;
export function isJuiceMuted() {
	try {
		return localStorage.getItem("juice.muted") === "true";
	} catch {
		return true;
	}
}
export function setJuiceMuted(muted: boolean) {
	try {
		localStorage.setItem("juice.muted", String(muted));
	} catch {
		/* recording remains available */
	}
}
export function installJuiceUnlock() {
	const unlock = () => {
		try {
			const Constructor =
				globalThis.AudioContext ??
				(window as Window & { webkitAudioContext?: typeof AudioContext })
					.webkitAudioContext;
			if (!Constructor) return;
			context ??= new Constructor();
			void context
				.resume()
				.then(() => {
					unlocked = true;
				})
				.catch(() => undefined);
		} catch {
			/* visible stamp remains */
		}
	};
	document.addEventListener("pointerdown", unlock, { capture: true });
	document.addEventListener("keydown", unlock, { capture: true });
	const background = () => {
		if (document.hidden) void context?.suspend().catch(() => undefined);
	};
	document.addEventListener("visibilitychange", background);
	return () => {
		document.removeEventListener("pointerdown", unlock, true);
		document.removeEventListener("keydown", unlock, true);
		document.removeEventListener("visibilitychange", background);
	};
}
export function playJuice(_cue: "stamp.collect", haptic?: () => void) {
	if (
		!unlocked ||
		isJuiceMuted() ||
		document.hidden ||
		matchMedia("(prefers-reduced-motion: reduce)").matches ||
		Date.now() - last < 150 ||
		!context ||
		context.state !== "running"
	)
		return;
	try {
		last = Date.now();
		const audio = context;
		const start = audio.currentTime;
		const gain = audio.createGain();
		gain.gain.setValueAtTime(0.0001, start);
		gain.gain.exponentialRampToValueAtTime(
			cues.cue.gain * cues.cue.volume,
			start + 0.012,
		);
		gain.gain.exponentialRampToValueAtTime(0.0001, start + cues.cue.duration);
		gain.connect(audio.destination);
		for (const [i, frequency] of cues.cue.frequencies.entries()) {
			const oscillator = audio.createOscillator();
			oscillator.type = "sine";
			oscillator.frequency.value = frequency;
			oscillator.connect(gain);
			oscillator.start(start + i * 0.025);
			oscillator.stop(start + cues.cue.duration);
			oscillator.onended = () => oscillator.disconnect();
		}
		setTimeout(() => gain.disconnect(), cues.cue.duration * 1000 + 100);
		if (haptic) haptic();
		else if ("vibrate" in navigator) navigator.vibrate(cues.haptic);
	} catch {
		/* audio never blocks saved state */
	}
}
